import { formatDateLocal } from '../../../../../lib/script'
import classes from './AppointmentHistoryItem.module.css'

const AppointmentHistoryItem = ({data}) => {

    return <div className={classes.item}>
        <span className={classes.date}>{formatDateLocal(data.date)}</span>
        <span className={classes.content}>
            {data.description && data.description}
            {!data.description && <>
                {data.event && data.event.name}
            </>}
        </span>
    </div>
}

export default AppointmentHistoryItem